import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';
import { isEmpty } from 'lodash';

import {
    Button,
    CircularProgress
} from '@material-ui/core';

import {
    Alert
} from '@material-ui/lab';

import { PageContext } from '../PageContext';

import { LicenseStatus } from '../../../../helpers';

import { useTranslation } from "react-i18next";

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {},
    alert: {
        marginBottom: theme.spacing(1)
    }
}));

export const BuildStatus = ({ ...props }) => {
    const classes = useStyles();

    const { t, i18n } = useTranslation();

    const {
        state,
        isBusy
    } = useContext(PageContext);

    const {
        license,
        settings,
        appConfig,
        buildStatus,
        buildError
    } = state;

    const buyLicenseClickHandler = (e) => {
        const buyUrl = `https://eshop.teamonair.com/eshop`;
        window.open(buyUrl, "_blank");
    }

    const [canBuildiOS, setCanBuildiOS] = useState(false);
    const [canBuildAndroid, setCanBuildAndroid] = useState(false);
    useEffect(() => {
        setCanBuildiOS(
            settings.iOSP12CertificateFile !== ""
            && settings.iOSMobileProvisionFile !== ""
            && settings.iOSCertificatePassword !== ""
        );
        setCanBuildAndroid(
            settings.androidKeyStoreFile !== ""
        //  && settings.androidKeyStoreAlias !== ""
            && settings.androidKeyStorePassword !== ""
        );
    }, [settings]);

    const [buildAlerts, setBuildAlerts] = useState({ message: null, error: null });
    useEffect(() => {
        setBuildAlerts({
            message: buildStatus !== null ? buildStatus.message : null,
            error: buildError
        });
    }, [buildStatus, buildError]);

    return (
        <div className={clsx(classes.root, props.className)}>

            {isBusy("enqueuing") &&
                <Alert className={classes.alert} icon={<CircularProgress size={20} />} variant="outlined" severity="info">
                    {t("LabelBuildIsInProgress")}
                </Alert>
            }

            {isBusy("download") &&
                <Alert className={classes.alert} icon={<CircularProgress size={20} />} variant="outlined" severity="info">
                    {t("LabelDownloadIsInProgress")}
                </Alert>
            }


            {license.status !== LicenseStatus.Active &&
                <Alert
                    className={classes.alert}
                    variant="outlined"
                    severity="warning"
                    action={
                        <Button
                            color="secondary"
                            size="small"
                            onClick={buyLicenseClickHandler}>
                            {t("ButtonBuyLicense")}
                        </Button>
                    }>
                    {t("LabelLicenseNotFound")}
                </Alert>
            }

            {settings.enableiOSBuild &&
                (canBuildiOS ?
                    <Alert className={classes.alert} variant="outlined" severity="success">
                        {t("LabelCanBuildiOS")}
                    </Alert>
                    :
                    <Alert variant="outlined" severity="warning">
                        {t("LabelCantBuildiOS")}
                    </Alert>
                )
            }

            {settings.enableAndroidBuild &&
                (canBuildAndroid ?
                    <Alert className={classes.alert} variant="outlined" severity="success">
                        {t("LabelCanBuildAndroid")}
                    </Alert>
                    :
                    <Alert className={classes.alert} variant="outlined" severity="warning">
                        {t("LabelCantBuildAndroid")}
                    </Alert>
                )
            }

            {isEmpty(appConfig) &&
                <Alert className={classes.alert} variant="outlined" severity="warning">
                    {t("LabelNoAppConfigToBuild")}
                </Alert>
            }

            {!settings.enableiOSBuild && !settings.enableAndroidBuild &&
                <Alert className={classes.alert} variant="outlined" severity="info">
                    {t("LabelCantBuildAnyPlatform")}
                </Alert>
            }

            {buildAlerts.message &&
                <Alert
                    className={classes.alert}
                    variant="outlined"
                    severity="success"
                    onClose={() => setBuildAlerts({ ...buildAlerts, message: null })}>
                    {buildAlerts.message}
                </Alert>
            }

            {buildAlerts.error &&
                <Alert
                    className={classes.alert}
                    variant="outlined"
                    severity="error"
                    onClose={() => setBuildAlerts({ ...buildAlerts, error: null })}>
                    {buildAlerts.error}
                </Alert>
            }

        </div>
    );
}